export const COOKIE_VISIBILITY_HIDDEN_CLASS = 'cookie-consent-hidden'
export const COOKIE_VISIBILITY_VISIBLE_CLASS = 'cookie-consent-visible'
